import { useMediaQuery } from '@mantine/hooks'
import { Typography } from '../common/typography'
import { useParams } from 'react-router'
import { useRaceDetails, useRaceStatsDetails } from './api'
import clsx from 'clsx'
import classes from './Races.module.css'
import Video from '../common/components/video/Video'
import PodiumLegendCard from './PodiumLegendCard'

export default function RaceHighlights() {
  const { competitionId, raceId } = useParams()
  const { data: race } = useRaceDetails({
    competition_id: Number(competitionId),
    race_id: Number(raceId),
  })
  const { data: raceStats } = useRaceStatsDetails({
    competition_id: Number(competitionId),
    race_id: Number(raceId),
  })
  const isDesktop = useMediaQuery('(min-width: 800px)')

  const src = race.video?.main

  return (
    <div
      className={clsx(classes.raceHighlightsContainer, {
        [classes.raceHighlightsContainerMobile]: !isDesktop,
      })}
    >
      <div>
        {src && <Video src={src} isMatch={false} />}
        {!src && <Typography>No video available for this match.</Typography>}
      </div>
      {raceStats.results.length > 0 && (
        <div
          className={clsx(classes.podiumLegendsContainer, {
            [classes.podiumLegendsContainerMobile]: !isDesktop,
          })}
        >
          {raceStats.results
            .filter((result) => [1, 2, 3].includes(result.rank))
            .map((result) => (
              <PodiumLegendCard result={result} />
            ))}
        </div>
      )}
    </div>
  )
}
